import React, { useEffect, useState } from 'react'
import { Animated } from 'react-native'
import { color } from '../../theme'

export const Skeleton = (props: any) => {
  const [opacity] = useState<Animated.Value>(new Animated.Value(0.1))
  const { style } = props

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(opacity, {
          toValue: 0.4,
          duration: 600,
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          toValue: 0.1,
          duration: 1000,
          useNativeDriver: true,
        }),
      ]),
    ).start()
  }, [opacity])

  return (
    <Animated.View
      style={{
        height: 300,
        width: 300,
        borderRadius: 16,
        alignSelf: 'center',
        backgroundColor: color.shade30,
        opacity,
        ...style,
      }}
    />
  )
}
